import { z } from "zod";

import { getUuidFromUrl } from "@nens/shared-utils";

/* A schema that turns URL into uuid. */

export const uuidSchema = z.preprocess((arg) => {
  if (typeof arg === "string") {
    return getUuidFromUrl(arg);
  } else {
    return null;
  }
}, z.string().nullable());
